var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMounted)?_c('big-title',[_vm._v(" Nuevo "),_c('span',[_vm._v("Beneficiario")]),_vm._v(". "),_c('p',{staticClass:"text-subtitle mt-6"},[_vm._v("Agrega la información necesaria para registrar al Beneficiario.")])]):_vm._e(),_c('beneficiary-form',{attrs:{"new-record":_vm.newRecord,"role":"client"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }